import { gql } from '@lichtblick/apollo';

export const GET_WORK_ORDER_APPOINTMENT_PM = gql`
  query GetWorkOrderAppointmentsPM($input: GetWorkOrderAppointmentsInput!) {
    getWorkOrderAppointments_V1(input: $input) {
      totalItems
      error
      data {
        id
        type
        status
        startDateUtc
        endDateUtc
        expectedDuration
        startScreenInformation
        isBinding
        teams {
          id
          name
        }
        branchOffice {
          id
          name
        }
        comment
        craftsmen {
          id
          firstName
          lastName
        }
        partnerCompanies {
          id
          name
        }
      }
    }
  }
`;
